import { render, staticRenderFns } from "./Charts.vue?vue&type=template&id=61a464d7"
import script from "./Charts.vue?vue&type=script&lang=ts"
export * from "./Charts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports